// Country flag emoji from ISO 3166-1 alpha-2 code (e.g. "US" -> 🇺🇸).
// 0x1F1E6 = regional indicator 'A'; 'A'.charCodeAt(0) = 65 -> diff 0x1F1A5.
export function flagFromCode(code) {
  if (!code || typeof code !== "string" || code.length < 2) return "";
  try {
    const cps = [...code.toUpperCase().slice(0, 2)].map(
      (c) => 0x1f1a5 + c.charCodeAt(0)
    );
    return String.fromCodePoint(...cps);
  } catch (_) {
    return "";
  }
}

// SVG flag URL from flagcdn.com (free CDN, no install required).
export function flagSvgUrl(code) {
  if (!code || typeof code !== "string" || code.length < 2) return "";
  return `https://flagcdn.com/${code.toLowerCase().slice(0, 2)}.svg`;
}

// Extract a clean hostname from a URL string (returns "" on failure).
export function hostFromUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url);
    return u.hostname.replace(/^www\./, "");
  } catch (_) {
    return "";
  }
}

// Lightweight relative-time formatter ("3 min ago", "2h ago", "5d ago").
// `dict` allows i18n: { now, secAgo, minAgo, hAgo, dAgo }.
export function formatRelative(iso, dict) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "";
  const diff = Math.max(0, Date.now() - t);
  const sec = Math.floor(diff / 1000);
  if (sec < 30) return dict.now;
  if (sec < 60) return `${sec}${dict.secAgo}`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} ${dict.minAgo}`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}${dict.hAgo}`;
  const day = Math.floor(hr / 24);
  return `${day}${dict.dAgo}`;
}

// Convert "*/15 * * * *" into a friendly label using i18n dict.
export function describeCron(cron, dict) {
  if (!cron) return dict.unknown;
  const m = String(cron).trim().match(/^\*\/(\d+)\s+\*\s+\*\s+\*\s+\*$/);
  if (m) return dict.everyNMin.replace("{n}", m[1]);
  return cron;
}

// Format a duration in ms as "1.4s" / "2m 13s".
export function formatDuration(ms, dict) {
  if (!ms || ms < 0) return "—";
  if (ms < 1000) return `${ms}${dict.ms}`;
  const sec = ms / 1000;
  if (sec < 60) return `${sec.toFixed(1)}${dict.s}`;
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}${dict.m} ${s}${dict.s}`;
}
